import styled from 'styled-components';
import { vars, pxToRem, getBreakpoint, fontWeight } from '$util/theme';
import TopBackground from '$layout/partials/TopBackground';

export default styled(TopBackground)`
  padding: 50px 15px 50px 15px;
  @media (min-width: ${getBreakpoint('md')}) {
    padding-top: 128px;
  }
  hgroup {
    text-align: center;
    h2 {
      max-width: 600px;
      margin: 0 auto;
    }
  }
  .main-card {
    max-width: 640px;
    margin: 40px auto;
    text-align: center;
    @media (min-width: ${getBreakpoint('md')}) {
      padding: 30px 85px;
    }
    > div {
      .title,
      .content {
        margin-bottom: 0;
      }

      .title {
        font-size: ${pxToRem(16)};
        line-height: 20px;
        color: ${vars.quantumverse.reskinColors.purple500};
        font-weight: ${fontWeight.bold};
        margin-bottom: 10px;
        @media (min-width: ${getBreakpoint('md')}) {
          font-size: ${pxToRem(17)};
          line-height: 22px;
        }
      }

      .content {
        font-size: ${pxToRem(15)};
        line-height: 20px;
        @media (min-width: ${getBreakpoint('md')}) {
          line-height: 22px;
        }
      }
    }
  }
  .part-of-renault {
    display: flex;
    justify-content: center;
  }
`;
